import 'twin.macro';
import React, { useEffect, useState } from 'react';
import CenterScreen from '@teetsh/app/src/components/CenterScreen';
import { Spinner } from '.';

export default function ScreenSpinner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <CenterScreen data-testid="loading">
      {show ? <Spinner size="3.5rem" tw="text-brand-intense" /> : null}
    </CenterScreen>
  );
}
